var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FFFAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 32H14.5C13.9696 32 13.4609 31.7893 13.0858 31.4142C12.7107 31.0391 12.5 30.5304 12.5 30V23C12.5 22.4696 12.7107 21.9609 13.0858 21.5858C13.4609 21.2107 13.9696 21 14.5 21H17.5M24.5 19V15C24.5 14.2044 24.1839 13.4413 23.6213 12.8787C23.0587 12.3161 22.2956 12 21.5 12L17.5 21V32H28.78C29.2623 32.0055 29.7304 31.8364 30.0979 31.524C30.4654 31.2116 30.7077 30.7769 30.78 30.3L32.16 21.3C32.2035 21.0134 32.1842 20.7207 32.1033 20.4423C32.0225 20.1638 31.8821 19.9063 31.6919 19.6875C31.5016 19.4687 31.2661 19.2939 31.0016 19.1752C30.7371 19.0565 30.4499 18.9967 30.16 19H24.5Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIcon);
export default __webpack_public_path__ + "c1e3ad8efaa9ef3c5d7b9f24d43771ec.svg";
export { ForwardRef as ReactComponent };